<template>
  <v-col
    class="d-flex align-center justify-end px-6 plans-filters"
    cols="6"
    data-qa="filter-bar">
    <FilterBar
      ref="filters"
      :all-headers="allHeaders"
      :choosed-headers.sync="choosed">
      <template #third_activator="{item}">
        <DateRangeDialog
          v-if="item.id == 'approvedSupplyDate'"
          data-qa="filter-bar-date-range"
          :search.sync="item.search"/>
        <Statuses
          v-if="item.id == 'receiver'"
          :key="item.id"
          data-qa="filter-bar-statuses-receiver"
          :item="item"
          item_key="id"
          item_title="name"
          :set-items="getDepartamentsItems"
          :type=" item.id "/>
        <Statuses
          v-if="item.id == 'applicant'"
          :key="item.id + creators.length "
          data-qa="filter-bar-statuses-applicant"
          :item="item"
          item_key="id"
          item_title="fullName"
          :set-items="creators"
          :type=" item.id "/>
        <CategoryDropdownTree
          v-if="item.id == 'category'"
          data-qa="filter-bar-category-dropdown"
          input-type="filter"
          :label="$t('Tenders.Category')"
          :model.sync="item.search"
          multiple/>
      </template>
    </FilterBar>
  </v-col>
</template>

<script>
import Statuses from 'components/common/blocks/Statuses.vue'
import FilterBar from 'components/common/blocks/FilterBar.vue'
import DateRangeDialog from 'components/common/dialogs/DateRangeDialog.vue'
import CategoryDropdownTree from 'components/common/dialogs/CategoryDropDownTree.vue'

import { mapGetters } from 'vuex'
import { storageMixin } from 'mixins'

export default {
  name: 'tableFilters',
  mixins: [storageMixin],
  data() {
    return {
      filters: [],
      searchValue: '',
      key: 1
    }
  },
  props: {
    customClass: String,
    allHeaders: Array,
    choosedHeaders: Array,
    departamentsData: Object,
    creators: Array,
  },
  computed: {
    ...mapGetters({
      changeOrganisation: 'changeOrganisation',
    }),
    choosed: {
      get() {
        return this.choosedHeaders
      },
      set(val) {
        this.$emit('update:choosedHeaders', val)
      }
    },
    getFiltersCount() {
      return  this.filters.filter(el => el.search.length ).length
    },
    getDepartamentsItems() {
      return Object.values(this.departamentsData)
    },
    getCategoriesItems() {
      return  this.$_.transform( this.categoriesData, (result, value, key) => {
        result.push({id: key, name: value})
      }, [])
    },
    /*storage_filters() {
      return this.$_getStorageFilters(true)
    },*/
  },
  components: {
    Statuses,
    FilterBar,
    DateRangeDialog,
    CategoryDropdownTree
  }
}
</script>
<style lang="scss" scoped>
.chip {
  font-weight: 400;
  height: 40px;
  border-width: 2px;
  border-radius: 31px;
  &.date-chip span:not(.black--text) {
    opacity: 0.5;
  }
}
</style>
<style lang="scss">

.planing-filters.filters-menu {
  max-width: 640px;
  width: 640px;
  padding: 10px 0;
  .no-filters-str {
    padding: 10px;
  }
  .input {
    min-width: 160px;
    width: 160px;
    &.selects {
      .select-value {
        font-size: 14px;
      }
      max-width: 385px;
      width: 385px;
    }
    &.case {
      min-width: 120px;
      width: 120px;
    }
    &.date-field {
      width: 500px;
    }
    .v-select__selection {
      font-size: 14px;
    }
    .v-text-field__slot {
      font-size: 14px;
    }
  }
  .v-input__slot, label {
    font-size: 12px;
    color: var(--black-color);
  }
  .footer {
    .v-btn__content {
      align-items: center;
    }
  }
}
.filters-menu-list {
  .v-text-field--rounded > .v-input__control > .v-input__slot {
    padding: 0 10px !important;
  }
}
</style>
